import { render } from "./Work.vue?vue&type=template&id=8e89857c"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC1\\Local Sites\\jpburato.now.sh.dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__